import React, { FC } from "react";
import { Grid, Hidden, Link, makeStyles, Typography } from "@material-ui/core";
import { Disclaimer } from "./Disclaimer";
import { ScrollTop } from "./ScrollTop";
import { ResponsiveGrid } from "./ResponsiveGrid";
import { Step } from "../types/Step";
import { useSelector } from "react-redux";
import { stepSelector } from "../store/engine/engine.selectors";
import { fonts } from "../style/customTheme";
import { ReactComponent as Electron } from "../icons/electron.svg";
import Maestro from "../icons/maestro.svg";
import { ReactComponent as Mastercard } from "../icons/mc.svg";
import { ReactComponent as AmericanExpress } from "../icons/amex.svg";
import { ReactComponent as Visa } from "../icons/visa.svg";
import { ReactComponent as Vpay } from "../icons/vpay.svg";

const imgStyle: React.CSSProperties = {
  margin: "0 4px",
  height: "30px",
};

const liStyle: React.CSSProperties = {
  display: "inline-block",
  marginRight: "25px",
  marginLeft: "25px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: 80,
    alignItems: "center",
    marginTop: 57,
    borderBottom: "2px solid rgba(0,0,0,0.12)",
    [theme.breakpoints.down("sm")]: {
      marginTop: 38,
    },
  },
  box: {
    width: 192,
    marginRight: 32,
    [theme.breakpoints.down("sm")]: {
      width: "initial",
    },
  },
  link: {
    textDecoration: "none",
  },
  disclaimer: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: 30,
    },
  },
}));

export const Footer: FC = () => {
  const classes = useStyles();
  const step = useSelector(stepSelector);
  const year = new Date().getFullYear();
  return (
    <ResponsiveGrid>
      <Grid container className={classes.root}>
        <Grid item xs={5} md={2}>
          <Typography variant="body1">Chi siamo?</Typography>
          <a
            href={"https://www.arag.it/arag-italia/"}
            target={"_blank"}
            rel="noopener noreferrer"
            className={classes.link}
          >
            <Typography variant={"h5"}>Vai su Arag.it</Typography>
          </a>
        </Grid>
        <Grid item xs={7} md={3}>
          <Typography variant="body1">Info</Typography>
          <a
            href={"https://www.arag.it/tutela-legale/"}
            target={"_blank"}
            rel="noopener noreferrer"
            className={classes.link}
          >
            <Typography variant={"h5"}>Cos&apos;&egrave; la tutela legale?</Typography>
          </a>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item>
          <Disclaimer />
        </Grid>
        {step !== Step.COSA && <Grid item className={classes.disclaimer} />}
      </Grid>

      <Grid container justify={"center"}>
        <Grid item>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "30px", marginBottom: "30px" }}>
            <Visa style={imgStyle} />
            <Electron style={imgStyle} />
            <Vpay style={imgStyle} />
            <Mastercard style={imgStyle} />
            <img src={Maestro} width={50} height={30} alt={"icona maestro"} />
            <AmericanExpress style={imgStyle} />
          </div>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              textAlign: "center",
              fontSize: "14px",
              fontFamily: fonts.sans,
              color: "#999",
            }}
          >
            <li style={liStyle}>
              <Link href="https://www.arag.it/privacy" underline={"always"} target="_blank" color={"inherit"}>
                Privacy
              </Link>
            </li>
            <li style={liStyle}>
              <Link href="https://www.arag.it/cookies" underline={"always"} target="_blank" color={"inherit"}>
                Cookies
              </Link>
            </li>
            <li style={liStyle}>
              <Link
                href={"https://www.arag.it/si/download/I/FP/FP/tradizionale_standard/IT"}
                underline={"always"}
                target="_blank"
                color={"inherit"}
              >
                Set informativo
              </Link>
            </li>
            <li style={liStyle}>
              <Link href="https://www.arag.it/contatti/reclami" underline={"always"} target="_blank" color={"inherit"}>
                Reclami
              </Link>
            </li>
            <li style={liStyle}>
              <Link
                href="https://www.arag.it/contatti/ripensamento"
                underline={"always"}
                target="_blank"
                color={"inherit"}
              >
                Diritto di ripensamento
              </Link>
            </li>
            <li style={liStyle}>
              <Link href="https://www.arag.it/azienda" underline={"always"} target="_blank" color={"inherit"}>
                © {year} ARAG
              </Link>
            </li>
          </ul>
        </Grid>
      </Grid>

      <Hidden smUp>
        <Grid container>
          <Grid item xs={2} />
          <Grid item xs={8}>
            <ScrollTop />
          </Grid>
        </Grid>
      </Hidden>
    </ResponsiveGrid>
  );
};
